import { useCallback, useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import { ShareButton } from '../../../components/ShareButtons';
import { Notify } from '../../../components/Notify';
import styles from './LandingBusinessCard.module.css';
import { ModalPosterPrint } from '../../../components/ModalPosterPrint';
import { useAuth } from '../../../hooks/useAuth';
import { QrcodeWithPdf } from '../../../components/QrcodeWithPdf';
import QRCode from 'qrcode.react';

export function LandingBusinessCard({ id, title, image }) {
  const { client, player } = useAuth();
  const [posterModalIsOpen, setPosterModalIsOpen] = useState(false);
  const [qrCodeModalIsOpen, setQrCodeModalIsOpen] = useState(false);
  const [share, setShare] = useState(false);
  const [cartazCover, setCartazCover] = useState<any>({});
  const [shareUrl, setShareUrl] = useState<string>();
  const [landingBusiness, setLandingBusiness] = useState({});

  useEffect(() => {
    const baseUrl =
      window.location.hostname === 'oqpwahom.web.app' ||
      window.location.hostname === 'oqpwahom.firebaseapp.com'
        ? 'https://oqpwahom.web.app'
        : 'https://app.oqdigital.com';
    setShareUrl(`${baseUrl}/landingBusiness/${player.id}/${id}`);
    setLandingBusiness({
      id: id,
      shareUrl: `${baseUrl}/landingBusiness/${player.id}/${id}`,
      actionTitle: title,
      images: image,
      defaultImagePoster: image,
    });
    generateBase64();
  }, []);

  const imageUrlToBase64 = async (url: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(new Error('Failed to read file'));
          reader.readAsDataURL(blob);
        })
        .catch(reject);
    });
  };

  const generateBase64 = useCallback(async () => {
    let imgBase64 = '';

    const logoImgBase64 = await imageUrlToBase64(client?.logoURL);
    const qrCodeBase64 = await imageUrlToBase64(
      `https://api.qrserver.com/v1/create-qr-code/?data=${shareUrl}`
    );

    imgBase64 = await imageUrlToBase64(image);

    setCartazCover({
      imageUrl: image?.url,
      imgBase64,
      logoImgBase64,
      qrCodeBase64,
    });
  }, []);

  return (
    <div className="col-12 col-sm-12 col-md-6 col-lg-4" key={id} id={id}>
      <div className={styles.cardReveal}>
        <div className={styles.cardBanner}>
          <img src={image} alt="imagem" />;
        </div>
        <div className={`${styles.cardTitle} text-truncate p-4`}>
          <span key={title}>{title}</span>
        </div>
        <div
          className={styles.clipboard}
          style={{
            maxWidth: '90%',
            marginLeft: 'auto',
            marginRight: 'auto',
            marginBottom: '15px',
          }}
        >
          <input
            className="px-4"
            placeholder="Link encurtado"
            value={shareUrl}
            disabled
            type="text"
          />
          <button
            onClick={() => {
              navigator.clipboard.writeText(shareUrl);
              Notify('Texto copiado com sucesso', 'success');
            }}
            className="p-4"
          >
            <i className="material-icons-outlined">content_copy</i>
          </button>
        </div>
        <div className={`${styles.cardAction}`}>
          <button
            className={styles.cta}
            onClick={() => {
              setShare(true);
            }}
          >
            <i className="material-icons-outlined mx-2">share</i>
            <span>Divulgar agora</span>
          </button>
        </div>
        {share && (
          <div className={styles.revealWrapper}>
            <div className={`${styles.reveal} ${share ? styles.open : ''}`}>
              <div className={`${styles.content} p-4`}>
                <div className={styles.topReveal}>
                  <span style={{ color: client.primaryColor }}>Divulgar</span>
                  <button onClick={() => setShare(false)}>
                    <i className="material-icons-outlined">close</i>
                  </button>
                </div>
                <div className="container">
                  <span>Divulgue rapidamente via</span>
                  <div className="my-3">
                    <ShareButton action={landingBusiness} />
                  </div>
                  <span>Ou copie o link</span>
                  <div className="mt-3">
                    <div className={styles.clipboard}>
                      <input
                        className="px-4"
                        placeholder="Link encurtado"
                        value={shareUrl}
                        disabled
                        type="text"
                      />
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(shareUrl);
                          Notify('Texto copiado com sucesso', 'success');
                        }}
                        className="p-4"
                      >
                        <i className="material-icons-outlined">content_copy</i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="container my-3" style={{ display: 'flex' }}>
                  <button
                    onClick={() => {
                      setQrCodeModalIsOpen(true);
                    }}
                    style={{
                      display: 'block',
                      background: 'none',
                      border: 'none',
                    }}
                  >
                    <span style={{ fontWeight: '700' }}>Gerar QR Code</span>
                    <i className="material-icons-outlined mx-2">
                      qr_code_scanner
                    </i>
                  </button>
                  <button
                    onClick={() => {
                      setPosterModalIsOpen(true);
                    }}
                    style={{
                      display: 'block',
                      background: 'none',
                      border: 'none',
                    }}
                  >
                    <span style={{ fontWeight: '700' }}>Gerar Cartaz</span>
                    <i className="material-icons-outlined mx-2">web</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <ModalPosterPrint
          modalIsOpen={posterModalIsOpen}
          closeModal={() => setPosterModalIsOpen(false)}
          clientPrimaryColor={client && client.primaryColor}
          playerName={player && player.name}
          action={landingBusiness}
          shareUrl={shareUrl}
          actionImagesBase64={cartazCover.imgBase64}
          cartazCover={cartazCover}
        />
        <Modal
          open={qrCodeModalIsOpen}
          onClose={() => setQrCodeModalIsOpen(false)}
          center
        >
          <div style={{ margin: '15px' }}>
            <div style={{ textAlign: 'center' }}>
              <h2>Qr code</h2>
            </div>
            {shareUrl && (
              <QRCode
                style={{ display: 'none' }}
                id="canvas-qrcode-share-url"
                value={shareUrl}
                size={600}
                className="text-center qrcode"
              />
            )}
            <QrcodeWithPdf valueQrcode={shareUrl ? shareUrl : ''} />
          </div>
        </Modal>
      </div>
    </div>
  );
}
